import { DEFAULT_PHONE_COUNTRY_CODE } from '@helpers/utils';
import { zodResolver } from '@hookform/resolvers/zod';
import { useTranslation } from 'react-i18next';
import { useForm } from 'react-hook-form';
import { TFunction } from 'i18next';
import { z } from 'zod';

const employeeFormSchema = (t: TFunction) =>
  z.object({
    firstName: z
      .string()
      .min(3, t('FORMS.MIN_CHARACTERS', { limit: 3 }))
      .max(50, t('FORMS.MAX_CHARACTERS', { limit: 50 })),
    lastName: z
      .string()
      .min(3, t('FORMS.MIN_CHARACTERS', { limit: 3 }))
      .max(50, t('FORMS.MAX_CHARACTERS', { limit: 50 })),
    phoneExt: z.string().min(1, t('FORMS.REQUIRED')),
    phoneNumber: z
      .string()
      .min(9, t('FORMS.MIN_CHARACTERS', { limit: '7' })) // 9 is min, we have 2 spaces in mask
      .max(19, t('FORMS.MAX_CHARACTERS')), // 15 is max, we have 4 spaces in mask
    email: z.string().email(t('FORMS.INVALID_EMAIL')).optional().or(z.literal('')),
    labels: z.array(z.string()).optional(),
    vehicles: z.array(z.string()).optional(),
  });

const defaultEmployeeValues = {
  firstName: '',
  lastName: '',
  phoneExt: DEFAULT_PHONE_COUNTRY_CODE,
  phoneNumber: '',
  email: '',
  labels: [],
  vehicles: [],
};

export type EmployeeFormType = z.infer<ReturnType<typeof employeeFormSchema>>;

export const useEmployeeForm = () => {
  const { t } = useTranslation();

  const form = useForm({
    resolver: zodResolver(employeeFormSchema(t)),
    defaultValues: defaultEmployeeValues,
    mode: 'onBlur',
  });

  return { form, defaultEmployeeValues };
};
